import React, { Component } from 'react';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import state from '../state';
import { l } from '../functions';
import { copyBlock, setShowBlockSettings } from '../core/redux/actions';
import WisywigCommandCenter from './WisywigCommandCenter';
import Icon from './Icons';

function duplicateIt(id, dropzoneID, parentID, external = false) {
  state.duplicateElement(id, dropzoneID, parentID, external);
}

const mapStateToProps = (state) => {
  return {
    // currentDevice: state.rootReducer.currentDevice || "xl",
    showBlockSettings: state.rootReducer.showBlockSettings ?? false,
    elementToEdit: state.rootReducer.elementToEdit || null,
    currentDevice: state.rootReducer.currentDevice || 'xl',
  };
};

class HoverBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentElement: null,
      popup: null,
    };
  }

  _changedCurrentLang = (lang) => {
    this.props.changedCurrentLang(lang.target.value);
  };

  _handleChangeContainer = (event) => {
    const { id, dropzoneID, parentID, payload } = this.props.element;

    const newPlayload = {
      ...payload,
      fullContainer: event,
      newRow: true,
    };

    state.updateElement(id, dropzoneID, parentID, {
      payload: newPlayload,
    });
  };

  componentWillReceiveProps(nextProps) {
    const last = document.getElementsByClassName('last-element');
    if (last.length) {
      for (const el of last) {
        if (el.offsetParent) {
          const bounds = el.getBoundingClientRect();
          const body = document.getElementsByClassName('canvas-area')[0];
          if (body) {
            const bodyBound = body.getBoundingClientRect();
            if (bounds.x > bodyBound.x + bodyBound.width) {
              el.offsetParent.classList.add('hover-right');
              break;
            }
          }
        }
      }
    }

    if (nextProps.parent == 'root' && !nextProps.row) {
      let isFluid = nextProps?.element?.payload?.fullContainer;
      if (isFluid === undefined) {
        isFluid = false;
        this._handleChangeContainer(isFluid);
      }
    }
    if (nextProps.row) {
      let isFluid = nextProps?.element?.payload?.fullContainer;
      let newRow = nextProps?.element?.payload?.newRow;
      if (isFluid == undefined) {
        this._handleChangeContainer(false);
      } else if (!newRow && isFluid) {
        this._handleChangeContainer(false);
      }
    }
  }

  _notInByPass = (type) => {
    return !['divider'].includes(type);
  };

  render() {
    const { id, dropzoneID, parentID, payload } = this.props.element;
    let hoverClass = '';

    if (this.props.type && this.props.type === 'text') hoverClass += 'hover-text ';

    if (this.props.parent === 'root' && !this.props.row) hoverClass += 'hover-parent ';

    if (this.props.row) hoverClass += 'hover-row ';

    let settingsIndex = 'settings';

    if (this.props.currentDevice != 'xl') settingsIndex = settingsIndex + '-' + this.props.currentDevice;

    const currentSettings = this.props.style[settingsIndex] || this.props.style.settings || {};

    const availableSettings = this.props.elementToEdit?.options?.settings || {};

    return (
      <div
        className={`hover-bar-container ${hoverClass} ${
          ['sm', 'xs'].includes(this.props.currentDevice) ? 'hover-bar-small' : ''
        }`}
        style={{
          ...currentSettings?.spacing,
          ...(this.props.elementToEdit?.type === 'product_stock_countdown'
            ? { top: -120 }
            : ['xs', 'sm'].includes(this.props.currentDevice)
            ? { top: -85 }
            : {}),
        }}
        onClick={(e) => e.stopPropagation()}
        id={id + 1}
      >
        <ul className={`hover-bar`} id='hover-bar'>
          {(Object.keys(availableSettings).length > 7 || this.props.elementToEdit?.type == 'checkout_form') &&
            this._notInByPass(this.props.elementToEdit?.type) && (
              <li>
                <Icon icon={'settings'} onClick={() => this.props.setSettingsOpen()} />
              </li>
            )}
          {!this.props.showBlockSettings && <WisywigCommandCenter currentDevices={this.props.currentDevice} />}
          <li>
            <button
              onClick={() => {
                this.props.copyBlock({
                  id: id,
                  json: state.getFullElement(id, dropzoneID, parentID),
                });
              }}
            >
              <FontAwesomeIcon icon={['fal', 'star']} />
            </button>
          </li>
          <li style={{ position: 'relative' }}>
            <button onClick={() => this.setState({ popup: this.state.popup ? null : 'copy' })}>
              <FontAwesomeIcon icon={['fal', 'copy']} />
            </button>

            {this.state.popup === 'copy' && (
              <ul className='popup'>
                <li>
                  <button onClick={() => duplicateIt(id, dropzoneID, parentID)}>
                    <FontAwesomeIcon icon={['fal', 'copy']} />
                  </button>
                </li>
                <li>
                  <button onClick={() => duplicateIt(id, dropzoneID, parentID, true)}>
                    <FontAwesomeIcon icon={['fal', 'copy']} />{' '}
                    <span style={{ margin: '0 4px' }}>{l('Other page')}</span>
                  </button>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Icon icon={'trash'} onClick={() => state.removeElement(id, dropzoneID, parentID)} />
          </li>
          {(this.props.parent === 'root' || this.props.row) && (
            <li onClick={() => this._handleChangeContainer(!payload.fullContainer)} className='width-row'>
              {payload.fullContainer ? (
                <>
                  <Icon icon='angle-right' />
                  <Icon icon='left-angle' />
                </>
              ) : (
                <>
                  <Icon icon='left-angle' />
                  <Icon icon='angle-right' />
                </>
              )}
            </li>
          )}

          {this.props.row && (
            <li>
              <button onClick={this.props.columnEdit} className={(this.props.rowActiveClass && 'active') || ''}>
                <Icon icon='c-width' />
              </button>
            </li>
          )}

          {!this.props.showBlockSettings && (
            <li className='last-element' id={id + 1}>
              <Icon icon='dots' onClick={() => this.props.setShowBlockSettings(true)} />
            </li>
          )}
        </ul>
      </div>
    );
  }
}
function setSettingsOpen() {
  return (dispatch) =>
    dispatch({
      type: 'SET_FLOAT_SETTINGS_OPEN',
      openFloatElementSettings: true,
    });
}
export default connect(mapStateToProps, {
  setShowBlockSettings,
  copyBlock,
  setSettingsOpen,
})(HoverBar);
